const PREPAID = 'Pago 100% por adelantado (antes de producir)';

const RADIO_VISUAL_FEATURES = [
  'Programa de 1 hora en vivo',
  'Estudio Multicámara + Streaming Global',
  '15 min de comerciales dentro de la hora',
  PREPAID,
];

const optionsData = [
  {
    title: 'SESIÓN MEDIA LAB',
    annualPrice: 40,
    monthlyPrice: 40,
    hideBillingToggle: true,
    prepaid: true,
    priceCaption: 'por sesión · pago por adelantado',
    features: [
      ...RADIO_VISUAL_FEATURES,
      'Incluye lo mismo que el plan mensual, cobrado por sesión',
      '4 sesiones al mes equivalen a $160; el plan mensual queda en $150 por pronto pago',
      'Add-on: Clips para redes $30/mes',
    ],
    idealFor:
      'Generadores de contenido que quieren grabar un episodio puntual o probar el Lab sin compromiso mensual.',
    duration: '1 sesión · Prepago',
    buttonText: 'Reservar sesión',
    highlightedTitle: 'Entra al Lab hoy',
    highlightedContent: [
      'Misma infraestructura broadcast que el plan mensual.',
      'Pagas la sesión antes de grabar: sin deudas ni sorpresas.',
      'Si produces todas las semanas, el plan mensual a $150 te ahorra vs pagar sesión por sesión.',
    ],
    highlightedButtonText: 'Agendar por WhatsApp',
  },
  {
    title: 'RADIO VISUAL SHOW',
    annualPrice: 450,
    monthlyPrice: 150,
    prepaid: true,
    priceCaption: 'al mes · pronto pago (ahorras vs 4 sesiones)',
    features: [
      'Programa de 1 hora semanal en vivo',
      'Estudio Multicámara + Streaming Global',
      '15 min de comerciales dentro de la hora',
      'Plan Monosponsor: 150$ (1 anunciante incluido)',
      'Plan Duo: 160$ (2 anunciantes x 80$ c/u)',
      'Plan Trio: 180$ (3 anunciantes x 60$ c/u)',
      'Pronto pago: $150/mes en lugar de $160 (4 sesiones a $40)',
      'Add-on: Clips para redes $30/mes',
      PREPAID,
    ],
    idealFor:
      'Locutores, talentos y figuras públicas que buscan un espacio fijo en TNO Network y monetizar con marcas.',
    duration: 'Mensual · Prepago / pronto pago',
    buttonText: 'Lanzar mi Programa',
    highlightedTitle: 'Tu show, un nicho vendible',
    highlightedContent: [
      'No vendemos cuñas genéricas en “el canal”: el anunciante entra a tu show y a su vertical.',
      'Paquete 360: mención en vivo, logo en miniatura, artículo en TNO y clips para redes.',
      'Pronto pago: $150 al mes vs $160 si pagas las 4 sesiones sueltas.',
    ],
    highlightedButtonText: 'Consultar política de patrocinio',
  },
  {
    title: 'PODCAST CREATOR PRO',
    annualPrice: 540,
    monthlyPrice: 180,
    prepaid: true,
    priceCaption: 'al mes · pago por adelantado',
    features: [
      'Episodios de hasta 2 horas de duración',
      'Grabación 100% libre de interrupciones',
      'Audio e Imagen 4K (Set dinámico)',
      'Entrega de Master de audio y video',
      'Add-on: Clips para redes $30/mes',
      PREPAID,
    ],
    idealFor:
      'Especialistas y marcas personales que exigen contenido premium sin cortes comerciales.',
    duration: 'Mensual / por temporada · Prepago',
    buttonText: 'Grabar mi Podcast',
    highlightedTitle: 'Pureza de mensaje',
    highlightedContent: [
      'Sin comerciales ni interrupciones: el tiempo es tuyo.',
      'Calidad cinematográfica para el streaming, el on-demand y las redes.',
      'Se paga por adelantado al inicio de cada mes o temporada.',
    ],
    highlightedButtonText: 'Conocer TNO Media Lab',
  },
  {
    title: 'MICRO-CONTENT LAB',
    annualPrice: 240,
    monthlyPrice: 80,
    prepaid: true,
    priceCaption: 'al mes · pago por adelantado',
    features: [
      'Cápsulas de 3 minutos de duración',
      'Rotación diaria cada 4 horas (6 salidas/día)',
      'Producción rápida en el Lab',
      'Presencia en cortes de toda la programación',
      'Add-on: Clips para redes $30/mes',
      PREPAID,
    ],
    idealFor: 'Noticias, tips, cápsulas de opinión y branding personal de alta frecuencia.',
    duration: 'Mensual · Prepago',
    buttonText: 'Producir mi Micro',
    highlightedTitle: 'Impacto constante',
    highlightedContent: [
      'Sé la voz que acompaña a la audiencia 24/7.',
      'Ideal para posicionar ideas potentes en poco tiempo.',
      'Frecuencia garantizada: tu marca sonará 180 veces al mes.',
    ],
    highlightedButtonText: 'Escuchar formato',
  },
  {
    title: 'DIGITAL EDITORIAL COLUMN',
    annualPrice: 120,
    monthlyPrice: 40,
    prepaid: true,
    priceCaption: 'al mes · pago por adelantado',
    features: [
      'Publicación de 4 artículos mensuales (1 semanal)',
      'Perfil de Autor verificado en el CMS',
      'Optimización SEO para posicionamiento en Google',
      'Plan Partner: $10 adicionales por cada anunciante',
      'Sin límite de anunciantes por artículo',
      PREPAID,
    ],
    idealFor:
      'Periodistas, bloggers, agencias de PR y especialistas que venden menciones en artículos.',
    duration: 'Mensual · Prepago',
    buttonText: 'Activar mi Columna',
    highlightedTitle: 'Monetiza tu pluma',
    highlightedContent: [
      'El modelo más flexible de la red: paga solo por lo que vendes.',
      'Ideal para backlinking y guest posting profesional.',
      'Tus artículos son activos digitales que generan tráfico y autoridad.',
    ],
    highlightedButtonText: 'Ver guía de redacción',
  },
  {
    title: 'CLIPS PARA REDES',
    annualPrice: 90,
    monthlyPrice: 30,
    prepaid: true,
    priceCaption: 'al mes · producto adicional · prepago',
    features: [
      'Clips editados extraídos de las entrevistas y el programa',
      'Selección de momentos con potencial de viralidad',
      'Subtítulos dinámicos listos para Reels, TikTok y Shorts',
      'Espacio para inserts de marca (product placement / colaboración)',
      'Monetización en colaboración con TNO Network',
      PREPAID,
    ],
    idealFor:
      'Talentos y productores que quieren reciclar cada entrevista en piezas para redes, con opción de inserts y revenue share junto a TNO Network.',
    duration: 'Mensual · producto adicional · Prepago',
    buttonText: 'Sumar clips a mi plan',
    highlightedTitle: 'Viraliza y monetiza',
    highlightedContent: [
      'No dejas el episodio solo en el aire: sale a redes en clips cortos con subtítulos.',
      'Los inserts abren un canal extra de pauta dentro del clip.',
      'La comercialización se hace en colaboración con TNO Network.',
    ],
    highlightedButtonText: 'Armar pack de clips',
  },
];

export default optionsData;
